export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8768.6e32ab39.jpg";